import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import useScript from 'hooks/useScript'
import fetch from 'isomorphic-unfetch'
import { useRef, useState, useEffect, useCallback } from 'react'

const useHubSpotForm = ({ portalId, formId, target }) => {
  const [loaded, error] = useScript({ src: '//js.hsforms.net/forms/v2.js' })
  const [formCreated, setFormCreated] = useState(false)
  const formRef = useRef(null)

  const handleMessageEvent = useCallback(async (event) => {
    if (event.data.type !== 'hsFormCallback') {
      return
    }

    // Apply styling to all forms (not just demo forms)
    if (event.data.eventName === 'onFormReady') {
      const frame = document.getElementById('hs-form-iframe-0')

      if (frame) {
        const form = frame?.contentWindow.document.querySelector('.hbspt-form')

        if (form) {
          form.querySelectorAll('.hs-richtext').forEach((pElement) => {
            pElement.style.fontSize = '10px'
            pElement.style.lineHeight = '1.8'
          })

          formRef.current = form
        }
      }
    }
  }, [])

  useEffect(() => {
    // Attach message listener for all forms (styling)
    window.addEventListener('message', handleMessageEvent)

    return () => {
      window.removeEventListener('message', handleMessageEvent)
    }
  }, [handleMessageEvent])

  useIsomorphicLayoutEffect(() => {
    if (!loaded || !window.hbspt || formCreated) {
      return
    }

    const loadForm = async () => {
      const result = await fetch('/api/country').then((res) => res.json())

      window.hbspt.forms.create({
        portalId,
        formId,
        target,
        onFormReady: function ($form) {
          if (result?.showDefaultConsentText === false) {
            // Remove existing .hs-richtext elements
            $form
              .querySelectorAll('.hs-richtext')
              .forEach((element) => element.remove())

            // Add the new consent message
            const consentDiv = document.createElement('div')
            consentDiv.classList.add('hs-richtext')

            const consentText = document.createElement('p')
            consentText.innerText =
              'Strapi needs the contact information you provide to us to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, check out our Privacy Policy.'

            consentDiv.appendChild(consentText)

            const legalContainer = $form.querySelector(
              '.legal-consent-container'
            )
            if (legalContainer) {
              legalContainer.appendChild(consentDiv)
            }
          }

          $form.querySelectorAll('.hs-richtext').forEach((pElement) => {
            pElement.style.fontSize = '10px'
            pElement.style.lineHeight = '1.8'
          })

          formRef.current = $form // Ensure formRef is set for later use
        },
        onFormSubmit: function () {
          // Form submitted
        },
        onFormSubmitted: function () {
          // Form submission completed
        },
      })

      setFormCreated(true)
    }

    loadForm()
  }, [loaded, formCreated, portalId, formId, target])

  return { loaded, formCreated, error }
}

export default useHubSpotForm
